import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['button']

  activateButton(e) {
    this.buttonTargets.forEach((button) => {
      button.classList.toggle('t-btn-active', button == e.currentTarget)
    })
  }
}
